$(document).ready(function () {
    $("#signup-page").css('display', "none");
    $(".create-account").click(function () {
        $("#login-page").css('display', "none");

        $("#signup-page").css('display', "flex");
    })
});